(function () {
  window.HushwingVersion = '4';
  if (window.console) console.log('[DIRTSHIFT] script v4 loaded');
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var t = m ? m[1] : 'amount';
    var v = cents / 100;
    var s = t.indexOf('no_decimals') > -1
      ? Math.round(v).toLocaleString('en-US')
      : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (t.indexOf('comma') > -1) s = s.replace(/,/g, '_').replace('.', ',').replace(/_/g, '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  function initProduct(root) {
    if (root.__hw) return;
    root.__hw = true;
    var jsonEl = root.querySelector('[data-hw-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-hw-form]');
    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('[data-hw-atc]');
    var atcLabel = form.querySelector('[data-hw-atc-label]');
    var totals = root.querySelectorAll('[data-hw-total]');
    var bundles = Array.prototype.slice.call(form.querySelectorAll('[data-hw-bundle]'));
    var bump = form.querySelector('[data-hw-bump]');
    var vbundles = Array.prototype.slice.call(form.querySelectorAll('[data-hw-vbundle]'));
    var optionInputs = form.querySelectorAll('[data-hw-option]');
    var slides = root.querySelectorAll('[data-hw-slide]');
    var thumbs = root.querySelectorAll('[data-hw-thumb]');
    var variant = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];

    function show(i) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-hw-slide') !== String(i); });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-hw-thumb') === String(i)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-hw-thumb')); }); });

    function update(fromOption) {
      if (vbundles.length) {
        var vb = vbundles.filter(function (x) { return x.checked; })[0];
        if (vb) {
          variant = data.variants.filter(function (x) { return String(x.id) === vb.value; })[0] || variant;
          idInput.value = variant.id;
          if (fromOption && variant.featured_media) {
            slides.forEach(function (s) {
              if (s.getAttribute('data-media-id') === String(variant.featured_media.id)) show(s.getAttribute('data-hw-slide'));
            });
          }
        }
      } else if (optionInputs.length) {
        var sel = data.options.map(function (_, i) {
          var c = form.querySelector('[data-hw-option="' + i + '"]:checked');
          return c ? c.value : null;
        });
        var nv = data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
        })[0];
        if (nv) variant = nv;
        idInput.value = variant.id;
        root.querySelectorAll('[data-hw-option-label]').forEach(function (el) {
          el.textContent = sel[+el.getAttribute('data-hw-option-label')] || '';
        });
        if (fromOption && variant.featured_media) {
          slides.forEach(function (s) {
            if (s.getAttribute('data-media-id') === String(variant.featured_media.id)) show(s.getAttribute('data-hw-slide'));
          });
        }
      }
      var total = variant.price;
      var selCmp = variant.compare_at_price || 0;
      var unitCompare = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      bundles.forEach(function (b) {
        var q = +b.value, off = +b.getAttribute('data-off') || 0;
        var now = Math.round(variant.price * q * (100 - off) / 100);
        var cmp = unitCompare * q;
        var opt = b.closest('.hw-opt');
        var n = opt.querySelector('[data-hw-now]'); if (n) n.textContent = money(now, data.money);
        var c = opt.querySelector('[data-hw-cmp]'); if (c) { c.textContent = cmp > now ? money(cmp, data.money) : ''; c.hidden = !(cmp > now); }
        var e = opt.querySelector('[data-hw-each]'); if (e) e.textContent = money(Math.round(now / q), data.money) + ' ' + data.eachLabel;
        if (b.checked) { total = now; selCmp = cmp; }
      });
      var baseNow = total;
      root.querySelectorAll('[data-hw-base]').forEach(function (el) { el.textContent = money(baseNow, data.money); });
      root.querySelectorAll('[data-hw-cmp-total]').forEach(function (el) { el.hidden = !(selCmp > baseNow); el.textContent = selCmp > baseNow ? money(selCmp, data.money) : ''; });
      root.querySelectorAll('[data-hw-save]').forEach(function (el) { var d = selCmp - baseNow; el.hidden = !(d > 0); if (d > 0) el.textContent = (el.getAttribute('data-label') || 'Save [amount]').replace('[amount]', money(d, data.money)); });
      if (bump && bump.checked) total += +bump.getAttribute('data-price');
      totals.forEach(function (el) { el.textContent = money(total, data.money); });
      atc.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? data.addLabel : data.soldLabel;
    }

    form.addEventListener('change', function (e) { update(e.target.hasAttribute('data-hw-option') || e.target.hasAttribute('data-hw-vbundle')); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var b = bundles.filter(function (x) { return x.checked; })[0];
      var q = b ? +b.value : 1;
      var item = { id: variant.id, quantity: q };
      if (b && +b.getAttribute('data-off')) item.properties = { _bundle: b.getAttribute('data-name') };
      var items = [item];
      if (bump && bump.checked) items.push({ id: +bump.value, quantity: 1 });
      atc.disabled = true;
      fetch(data.root.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); atc.disabled = false; return; }
        afterAdd();
      }).catch(function () { atc.disabled = false; form.action = form.getAttribute('data-action'); form.submit(); });
    });

    var base = data.root.replace(/\/$/, '');
    var modal = root.querySelector('[data-hw-modal]');
    if (window.console) console.log('[DIRTSHIFT] upsell pop-up ' + (modal ? 'ready' : 'missing: turn on "Show upsell pop-up" in the buy box'));
    var cartTotal = 0, autoDone = false;
    var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function ups() { return modal ? Array.prototype.slice.call(modal.querySelectorAll('[data-hw-up-check]')) : []; }
    function redirect() { location.href = data.after === 'checkout' ? base + '/checkout' : data.cartUrl; }
    function upTotal() {
      var add = 0;
      ups().forEach(function (u) { if (u.checked) add += +u.getAttribute('data-price'); });
      var n = modal.querySelector('[data-hw-up-total]');
      if (n) n.textContent = money(cartTotal + add, data.money);
    }
    function setActive(id) {
      modal.querySelectorAll('[data-hw-up-detail]').forEach(function (d) { d.hidden = d.getAttribute('data-hw-up-detail') !== id; });
      modal.querySelectorAll('[data-hw-up]').forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-hw-up') === id); });
    }
    function bindRow(r) {
      var id = r.getAttribute('data-hw-up');
      r.addEventListener('mouseenter', function () { setActive(id); });
      r.addEventListener('focusin', function () { setActive(id); });
      r.addEventListener('change', function () { setActive(id); upTotal(); });
    }
    function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function textOf(html) { var d = document.createElement('div'); d.innerHTML = html || ''; var t = (d.textContent || '').trim().split(/\s+/); return t.slice(0, 40).join(' ') + (t.length > 40 ? '…' : ''); }
    function cents(x) { if (typeof x === 'number') return x; var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n * 100); }
    function norm(p) {
      var im = p.featured_image || (p.images && p.images[0]) || '';
      if (im && typeof im === 'object') im = im.src || '';
      return {
        id: p.id, title: p.title, description: p.description || p.body_html || '', featured_image: im,
        variants: (p.variants || []).map(function (v) {
          var fromAjax = typeof p.price === 'number' || typeof v.price === 'number';
          return { id: v.id, available: v.available !== false, price: fromAjax ? v.price : cents(v.price), compare_at_price: v.compare_at_price == null ? 0 : (fromAjax ? v.compare_at_price : cents(v.compare_at_price)) };
        })
      };
    }
    function getCollection() {
      return fetch(base + '/collections/' + encodeURIComponent(data.upCollection || 'all') + '/products.json?limit=12', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    function buildAuto(products) {
      products = products.map(norm);
      var L = modal.querySelector('[data-hw-up-list]'), D = modal.querySelector('[data-hw-up-details]'), n = 0;
      products.forEach(function (p) {
        if (n >= 3 || String(p.id) === String(data.productId)) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) return;
        n++;
        var id = 'auto-' + p.id, src = p.featured_image || (p.images && p.images[0]) || '';
        var row = document.createElement('label');
        row.className = 'hw-up' + (n === 1 ? ' is-active' : '');
        row.setAttribute('data-hw-up', id);
        row.innerHTML = '<input type="checkbox" value="' + v.id + '" data-price="' + v.price + '" data-hw-up-check>' +
          '<span class="hw-check">' + CHECK + '</span>' +
          '<span class="hw-up__img">' + (src ? '<img src="' + esc(img(src, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="hw-up__main"><b>' + esc(p.title) + '</b></span>' +
          '<span class="hw-up__price">' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price, data.money) + '</s>' : '') + '<span>+' + money(v.price, data.money) + '</span></span>';
        L.appendChild(row);
        var det = document.createElement('div');
        det.className = 'hw-up-detail';
        det.setAttribute('data-hw-up-detail', id);
        if (n > 1) det.hidden = true;
        det.innerHTML = '<div class="hw-media" style="--ratio:4/3">' + (src ? '<img src="' + esc(img(src, 900)) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<h3>' + esc(p.title) + '</h3><div class="hw-rte"><p>' + esc(textOf(p.description)) + '</p></div>';
        D.appendChild(det);
        bindRow(row);
      });
      if (n) modal.classList.remove('hw-modal--empty');
    }
    function getRecs(intent) {
      return fetch(base + '/recommendations/products.json?product_id=' + data.productId + '&limit=6&intent=' + intent, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    function loadAuto() {
      var mode = modal.getAttribute('data-hw-auto');
      if (!mode || autoDone) return Promise.resolve();
      autoDone = true;
      return getRecs(mode).then(function (list) {
        return list.length || mode === 'related' ? list : getRecs('related');
      }).then(function (list) {
        var ok = list.filter(function (p) { return String(p.id) !== String(data.productId); });
        if (ok.length) return list;
        if (window.console) console.log('[DIRTSHIFT] no Shopify recommendations yet, using collection: ' + (data.upCollection || 'all'));
        return getCollection();
      }).then(buildAuto);
    }
    function onKey(e) { if (e.key === 'Escape') closeModal(); }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('hw-lock');
      document.removeEventListener('keydown', onKey);
      atc.disabled = !variant.available;
    }
    function openModal(cart) {
      cartTotal = cart.total_price || 0;
      document.querySelectorAll('.hw-cart').forEach(function (c) {
        var b = c.querySelector('.hw-cart__n');
        if (!b) { b = document.createElement('span'); b.className = 'hw-cart__n'; c.appendChild(b); }
        b.textContent = cart.item_count;
      });
      upTotal();
      modal.hidden = false;
      document.body.classList.add('hw-lock');
      document.addEventListener('keydown', onKey);
      var x = modal.querySelector('.hw-modal__x'); if (x) x.focus();
    }
    function afterAdd() {
      if (!modal) { redirect(); return; }
      Promise.all([
        fetch(base + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        loadAuto()
      ]).then(function (res) { openModal(res[0]); }).catch(redirect);
    }
    if (modal) {
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.querySelectorAll('[data-hw-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
      modal.querySelectorAll('[data-hw-up]').forEach(bindRow);
      var go = modal.querySelector('[data-hw-go]');
      go.addEventListener('click', function () {
        var co = base + '/checkout';
        var items = ups().filter(function (u) { return u.checked; }).map(function (u) { return { id: +u.value, quantity: 1 }; });
        if (!items.length) { location.href = co; return; }
        go.disabled = true;
        fetch(base + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () { location.href = co; }).catch(function () { location.href = co; });
      });
    }

    var sticky = root.querySelector('[data-hw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis) seen = true;
        var past = !vis && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', String(!past));
      }).observe(atc);
      sticky.querySelector('[data-hw-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
    update(false);
  }

  function boot() { document.querySelectorAll('[data-hw-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-hw-product]'); if (r) initProduct(r);
  });
})();
